import { useABContextWrapper } from '@as-react/common-components';
import { HybridCookieUtil } from '@as-react/common-utils';
// This hook provides us with 3 properties:
// 1. getCookie: returns the value of the AB test cookie
// 2. hasBCookie: returns true if the cookie value is 'B'
// 3. hasCCookie: returns true if the cookie value is 'C'
export const useABTest = (abTestCookie) => {
    const abContext = useABContextWrapper();
    const hybridCookieUtil = new HybridCookieUtil();
    return typeof document !== 'undefined'
        ? {
            getCookie: hybridCookieUtil.getCookie(abTestCookie),
            hasBCookie: hybridCookieUtil.hasBCookie(abTestCookie),
            hasCCookie: hybridCookieUtil.hasCCookie(abTestCookie),
        }
        : {
            getCookie: abContext === null || abContext === void 0 ? void 0 : abContext[abTestCookie],
            hasBCookie: abContext === null || abContext === void 0 ? void 0 : abContext[abTestCookie],
            hasCCookie: abContext === null || abContext === void 0 ? void 0 : abContext[abTestCookie],
        };
};
